jQuery( document ).ready( function( $ ) {


    /**
     * AOS init
     */
    if($('.team--bio').length){
      AOS.init();
    }  


    /**
     * Add class to navbar-toggler when clicked
     */
    $('.navbar-toggler').click(function() {
        $(this).toggleClass('open');
        $('.main-navigation').toggleClass('closed');
        $('.main-navigation').toggleClass('open');
        $('body').toggleClass('locked');
    });


    /**
     * Remove mobile menu animation class
     */
    function remove_mobile_menu() {
        var nav_selector = $('.site-header .navbar');
        var responsive_breakpoint = '';

        if ( nav_selector.hasClass("navbar-expand-lg") ) {
          responsive_breakpoint = 992;
        } else if ( nav_selector.hasClass("navbar-expand-md") ) {
          responsive_breakpoint = 768;
        } else if ( nav_selector.hasClass("navbar-expand-sm") ) {
          responsive_breakpoint = 576;
        }

        if ( $(window).width() >= responsive_breakpoint ) {
          if ( $('.main-navigation').hasClass('open') ) {
            $('.navbar-toggler').toggleClass('open');
            $('.main-navigation').toggleClass('closed');
            $('.main-navigation').toggleClass('open');
            $('body').toggleClass('locked');
          }
        }      
    }

    // Run function on window resize, if window size matches - remove class
    // See above
    $(window).resize(function() {
        remove_mobile_menu();
    });    


    // Move social links to inside/below mobile nav
    $('.main-navigation--inner').append( $('.main-navigation .social-links') );


    // Jump all about page pagination to the team section
    if(document.location.pathname.indexOf("/about/page") == 0) {
      $('html, body').animate({ scrollTop: $('#meet-the-team').offset().top}, 1000);
    }    


    /**
     * Brands containers (Brands page) hover
     */
    $('.brand-content').hover(function() {
      $(this).find('.knockout-logo').toggleClass('d-none');
      $(this).find('.primary-logo').toggleClass('d-none');
    });

    $('.brand-content').on('touchstart',function(e){
      console.log('touchstart');
      e.preventDefault();
      window.location = $(this).find("a").attr("href"); 
      return false;
    });   


    /**
     * Create a "clickable" class which makes entire container clickable
     */
    $(".clickable").click(function() {
        window.location = $(this).find("a").attr("href"); 
        return false;
    });


    /**
     * Set cookie for site notification dismissal
     */
    if ($.cookie('site_note_close') != 'true') {
      $('.site-notification').removeClass('d-none');

      $('.site-note-close').click(function() {
        $.cookie('site_note_close', 'true', { expires: 10, path: '/' }); 
      });
    } else if ($.cookie('site_note_close') === 'true') {        
    };     
  
  
    /**
     * Default Slick Slider Example
     */
    $('.general-slider.slick-slideshow').slick({
      dots: false,
      arrows: true,      
      slidesToShow: 4,
      slidesToScroll: 1,      
      lazyLoad: 'progressive',      
      prevArrow: '<div class="slider-prev"><img src="/wp-content/themes/waypoint-outdoor/includes/images/img--arrow-left.svg"></div>',
      nextArrow: '<div class="slider-next"><img src="/wp-content/themes/waypoint-outdoor/includes/images/img--arrow-right.svg"></div>',
      responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]          
    });

    $('.brands-slider.slick-slideshow').slick({
      dots: false,
      arrows: true,      
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,     
      lazyLoad: 'progressive',      
      prevArrow: '<div class="slider-prev"><img src="/wp-content/themes/waypoint-outdoor/includes/images/img--arrow-left.svg"></div>',
      nextArrow: '<div class="slider-next"><img src="/wp-content/themes/waypoint-outdoor/includes/images/img--arrow-right.svg"></div>',
      responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]          
    });

    $('.partnership-slider.slick-slideshow').slick({
      dots: false,
      arrows: true,      
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,     
      lazyLoad: 'progressive',      
      prevArrow: '<div class="slider-prev"><img src="/wp-content/themes/waypoint-outdoor/includes/images/img--arrow-left.svg"></div>',
      nextArrow: '<div class="slider-next"><img src="/wp-content/themes/waypoint-outdoor/includes/images/img--arrow-right.svg"></div>',
      responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]          
    });    

    $("#modalToggle1,#modalToggle2,#modalToggle3").on("shown.bs.modal", function() {
        $(".showroom-slider.slick-slideshow").slick({
      dots: true,
      arrows: false,      
      slidesToShow: 1,
      slidesToScroll: 1,
        });
    });

    $("#modalToggle1,#modalToggle2,#modalToggle3").on("hide.bs.modal", function() {
        $(".showroom-slider.slick-slideshow").slick('unslick');
    });
    /*$('.showroom-slider.slick-slideshow').slick({
      dots: true,
      arrows: false,      
      slidesToShow: 1,
      slidesToScroll: 1,
    }); */       


    $('.card giving--content').matchHeight({
      byRow: false,
    });
    //$('.team--bio-image').matchHeight();    


    /**
     * Smooth Scroll Hashed Links
     * This will scroll to link on same page
     * Or will smoothly scroll to a hashed section on another page after click
     */

    $(function() {
      // your current click function
      // select all links with hashes, remove if don't link to anything (:not)
      // this is for same page hashed links
      $('a[href*=\\#]:not([href=\\#])').on('click', function() {
          if (!$(this).parents('ul').hasClass('nav-tabs') && !$(this).hasClass('showroom-title')) {
              var target = $(this.hash);
              // if target.length is 0, set target equal to the name attribuite with hash as value
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // smooth scroll to the target id
              if (target.length) {
                  $('html,body').animate({
                      scrollTop: target.offset().top
                  }, 1000);
                  return false;
              }
          }
      });

      // check if the window location (URL) has a hash in it
      // smoothly scroll to that location
      if(window.location.hash) {
          var target = $(window.location.hash);
          // if target.length is 0, set target equal to the name attribuite with hash as value
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          // smooth scroll to the target id
          $('html, body').delay(1000).animate({
            scrollTop: $(target).offset().top + 'px'
          }, 1000);
          return false;
      }

    });


    /**
     * Reveal job application form section when button is clicked
     */
    $('.career-form-reveal').click(function() {
        $('.career-form-container').toggleClass('d-none');
    });
} );
